import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { DOCUMENT, WINDOW } from '@core/injection-tokens';
import { MOCK_FEEDBACK_CONTENT } from '@dynamic-components/feedback/feedback.response.mock';
import { FeedbackContent } from '@dynamic-components/feedback/feedback.type';
import { registerLogFullStory } from '@shared/ui/utils/global-utils/full-story';
@Component({
  selector: 'jb-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackComponent implements OnInit {
  @Input() feedback: FeedbackContent;
  showNegativeForm = false;
  showPositiveForm = false;
  readonly STAR_AMOUNT = 5;
  stars: number[];
  hoveredStars: number[];
  feedbackSubmitted = false;
  reasonsToSubmit: string[] = [];
  isHovered: boolean;

  constructor(
    @Inject(DOCUMENT) private document,
    @Inject(WINDOW) private window,
  ) {}

  ngOnInit() {
    this.stars = Array(this.STAR_AMOUNT).fill(0);
    this.hoveredStars = Array(this.STAR_AMOUNT).fill(0);
    this.isHovered = false;
  }

  onClickNegativeFeedback() {
    this.showNegativeForm = true;
  }

  onClickPositiveFeedback() {
    this.showPositiveForm = true;
  }

  onCheckboxValueChange(checked: boolean, reason: string) {
    if (!!checked) {
      this.reasonsToSubmit.push(reason);
    } else {
      const index = this.reasonsToSubmit.indexOf(reason);
      this.reasonsToSubmit.splice(index, 1);
    }
  }

  submitFeedback(isNegative: boolean, comment: string) {
    this.feedbackSubmitted = true;
    const starRating = this.stars.reduce(
      (total, x) => (x === 1 ? total + 1 : total),
      0,
    );
    registerLogFullStory(
      'Feedback Submit',
      {
        page_title_str: this.document.title,
        page_path_str: this.window.location.href,
        negative_feedback_bool: isNegative,
        reasons_str: this.reasonsToSubmit.join(', '),
        feedback_text: comment,
        star_rating: starRating === 0 ? undefined : starRating,
      },
      this.window,
    );
  }

  onStarClick(index: number) {
    this.stars.fill(1, 0, index + 1);
    this.stars.fill(0, index + 1, this.STAR_AMOUNT);
  }

  onStarHoverOut() {
    this.isHovered = false;
    this.hoveredStars = Array(this.STAR_AMOUNT).fill(0);
  }

  onStarHoverIn(index: number) {
    this.isHovered = true;
    this.hoveredStars.fill(1, 0, index + 1);
    this.hoveredStars.fill(0, index + 1, this.STAR_AMOUNT);
  }
}

export const feedbackResolver = (registry, data) => ({
  feedback: data.feedback ? data.feedback[0] : MOCK_FEEDBACK_CONTENT,
});
